var g = Object.defineProperty;
var m = (e, t, r) => t in e ? g(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var n = (e, t, r) => m(e, typeof t != "symbol" ? t + "" : t, r);
import { LOGGER as O, COOKIE_SERVICE as C } from "@packages/common";
import { CONFIG as d } from "@packages/config";
import { Injectable as _, Inject as h } from "@webmotors/ioc";
import "./main18.js";
import { COOKIE_CONSENTS_SERVICE as p } from "./main19.js";
import { LastSearchesEntryDTO as y } from "./main87.js";
import { LAST_SEARCHES_SERVICE as E } from "./main28.js";
var A = Object.getOwnPropertyDescriptor, f = (e, t, r, o) => {
  for (var i = o > 1 ? void 0 : o ? A(t, r) : t, s = e.length - 1, a; s >= 0; s--)
    (a = e[s]) && (i = a(i) || i);
  return i;
}, l = (e, t) => (r, o) => t(r, o, e);
let u = class {
  constructor(e, t, r, o) {
    n(this, "COOKIE_NAME");
    n(this, "DAYS_TO_EXPIRE", 90);
    n(this, "MAX_COOKIE_LENGTH", 4e3);
    n(this, "MAX_SEARCH_HISTORY", 10);
    n(this, "logger");
    this.config = e, this.loggerFactory = t, this.cookieService = r, this.cookieConsentsService = o, this.logger = this.loggerFactory.create(E), this.COOKIE_NAME = this.config.lastSearchesCookieName || "";
  }
  /**
   * Parse last searches cookie value from raw string.
   * Useful for SSR where cookieService is not available.
   *
   * @param cookieValue - Raw cookie value as string.
   * @returns Array of parsed last searches.
   */
  parseLastSearchesCookie(e) {
    try {
      if (!e) return [];
      const t = JSON.parse(
        decodeURIComponent(e)
      );
      return Array.isArray(t) ? t.map((r) => {
        const o = new URLSearchParams(r.query), i = o.get("marca1") || void 0, s = o.get("modelo1") || void 0, a = o.get("estadocidade") || void 0;
        let c;
        return r.route.includes("motos") ? c = "bike" : r.route.includes("carros") && (c = "car"), {
          brand: i,
          model: s,
          vehicleType: c,
          location: a,
          route: r.route,
          query: r.query,
          fullUrl: `${r.route}${r.query}`
        };
      }) : [];
    } catch (t) {
      return console.error("[parseLastSearchesCookie] Error:", t), [];
    }
  }
  clearAll() {
    this.logger.log("[clearAll] clearing search cookies: ", this.COOKIE_NAME), this.cookieService.removeCookie(this.COOKIE_NAME);
  }
  /**
   * Save a new search entry into the cookie if the cookie category is active and filters are valid.
   *
   * @param filters - Filters used for the search.
   * @param url - URL of the search.
   */
  async save({
    filters: e,
    url: t
  }) {
    try {
      if (!this.COOKIE_NAME || !await this.cookieConsentsService.isSearchEnabled() || !this.isValidFilters(e))
        return;
      const r = this.get(), [o = "", i = ""] = t.split("?");
      if (!o || !i)
        return;
      const s = new y({
        route: o,
        query: `?${i}`
      }), a = this.removeIfAlreadySearchExists(
        r,
        s
      ), c = this.ensureCookieSizeLimit([
        s,
        ...a
      ]);
      this.cookieService.save(this.COOKIE_NAME, c, {
        expires: this.getExpirationDate()
      });
    } catch (r) {
      this.logger.error("[Set] Failed to set lastSearchesCookie.", r);
      return;
    }
  }
  /**
   * Retrieve the search history from the cookie.
   *
   * @returns The list of saved searches.
   */
  get() {
    try {
      if (!this.COOKIE_NAME)
        return [];
      const e = this.cookieService.get(this.COOKIE_NAME) ?? [];
      return Array.isArray(e) ? e : [];
    } catch (e) {
      return this.logger.error("[Get] Failed to get lastSearchesCookie.", e), [];
    }
  }
  /**
   * Retrieve and parse the search history from the cookie.
   *
   * @returns Array of parsed last searches with extracted information.
   */
  getParsed() {
    try {
      const e = this.get(), t = JSON.stringify(e);
      return this.parseLastSearchesCookie(t);
    } catch (e) {
      return this.logger.error(
        "[GetParsed] Failed to parse lastSearchesCookie.",
        e
      ), [];
    }
  }
  /**
   * Validate if the filters are suitable for saving the search.
   *
   * @param filters - Filters to validate.
   * @returns True if valid, otherwise false.
   */
  isValidFilters(e) {
    var o, i, s, a, c, S;
    const t = ((s = (i = (o = e.makes) == null ? void 0 : o[0]) == null ? void 0 : i[0]) == null ? void 0 : s.name) === "marca", r = ((S = (c = (a = e.makes) == null ? void 0 : a[0]) == null ? void 0 : c[1]) == null ? void 0 : S.name) === "modelo";
    return t && r && !!e.vehicleType;
  }
  /**
   * Check if a search entry already exists in the history.
   * If it exists, remove it.
   *
   * @param searches - Existing search history.
   * @param newSearch - The new search entry to check and update.
   * @returns The updated array of searches.
   */
  removeIfAlreadySearchExists(e, t) {
    try {
      const r = new URLSearchParams(t.query);
      r.sort();
      const o = `${t.route}?${r.toString()}`;
      return e.filter((s) => {
        const a = new URLSearchParams(s.query);
        return a.sort(), `${s.route}?${a.toString()}`.toLowerCase() !== o.toLowerCase();
      });
    } catch {
      return e;
    }
  }
  /**
   * Ensure the cookie does not exceed the size or history length limits.
   *
   * @param searches - List of searches to validate.
   * @returns The trimmed list of searches.
   */
  ensureCookieSizeLimit(e) {
    const t = this.MAX_SEARCH_HISTORY;
    for (let r = t; r > 0; r--)
      if (JSON.stringify(e.slice(0, r)).length <= this.MAX_COOKIE_LENGTH)
        return e.slice(0, r);
    return [];
  }
  /**
   * Generate the expiration date for the cookie.
   *
   * @returns The expiration date.
   */
  getExpirationDate() {
    return new Date(Date.now() + this.DAYS_TO_EXPIRE * 24 * 60 * 60 * 1e3);
  }
};
u = f([
  _(E),
  l(0, h(d)),
  l(1, h(O)),
  l(2, h(C)),
  l(3, h(p))
], u);
export {
  u as LastSearchesService
};
